import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=36b70972&scoped=true&"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b70972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b70972')) {
      api.createRecord('36b70972', component.options)
    } else {
      api.reload('36b70972', component.options)
    }
    module.hot.accept("./DeleteConfirmation.vue?vue&type=template&id=36b70972&scoped=true&", function () {
      api.rerender('36b70972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/DeleteConfirmation.vue"
export default component.exports